export const Label = ({ title }) => {
    return `<div class="label">${title}</div>`;
};
